var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.287 13.274h2.717V6.35a.82.82 0 0 1 .822-.822.82.82 0 0 1 .822.822l-.002 7.749a.821.821 0 0 1-.822.822h-3.54a.823.823 0 0 1 .003-1.646zm1.141-6H7.711v6.925a.82.82 0 0 1-.822.822.82.82 0 0 1-.822-.822l.002-7.75a.821.821 0 0 1 .822-.821h3.539a.823.823 0 0 1-.002 1.645zM20 10c0-5.514-4.486-10-10-10S0 4.486 0 10c0 5.513 4.486 10 10 10s10-4.487 10-10z",
    fill: "#453FBB",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.bf274f61092cae80cabe64035f23ea3a.svg";
export { ForwardRef as ReactComponent };